import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { FaChevronDown, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa'
import './Hero.css'

// Import skutečných fotek
import exterier1 from '../album/jilovanka.jpg'
import exterier2 from '../album/MainFotka.jpg'

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const slides = [
    {
      image: exterier1,
      title: 'Chata Jílovanka',
      subtitle: 'Ubytování v krásném prostředí v srdci Orlických hor',
      description: 'Ideální místo pro rodinné dovolené, firemní akce a skupinové pobyty'
    },
    {
        image: exterier2,
        title: 'Pohodlné ubytování',
        subtitle: '9 pokojů s vlastním sociálním zařízením',
        description: 'Každý pokoj má WC, sprchový kout a umyvadlo'
      },
/*     {
      image: exterier3,
      title: 'Stylové exteriéry',
      subtitle: 'Kombinace tradice a moderny',
      description: 'Elegantní zařízení s důrazem na pohodlí'
    },
    {
      image: exterier4,
      title: 'Relaxační zóny',
      subtitle: 'Místa pro odpočinek a zábavu',
      description: 'Společenské prostory pro všechny hosty'
    },
    {
      image: exterier5,
      title: 'Výhledy do přírody',
      subtitle: 'Okna s panoramatickými výhledy',
      description: 'Probuďte se s krásným výhledem na hory'
    },
     */
  ]

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length)
    }, 5000)
    return () => clearInterval(timer)
  }, [slides.length])

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
  }

  const scrollToAbout = () => {
    const aboutSection = document.querySelector('.about-section')
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <motion.div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: index === currentSlide ? 1 : 0 }}
            transition={{ duration: 0.5 }}
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${slide.image})`
            }}
          >
            <div className="hero-content">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="hero-text"
              >
                {React.createElement(
                  index === currentSlide ? 'h1' : 'div',
                  { className: 'hero-title' },
                  slide.title
                )}
                <h2 className="hero-subtitle">{slide.subtitle}</h2>
                <p className="hero-description">{slide.description}</p>
                <div className="hero-buttons">
                  <motion.a
                    href="#kontakt"
                    className="btn btn-primary btn-large"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <FaPhone />
                    Rezervace
                  </motion.a>
                  <motion.button
                    onClick={scrollToAbout}
                    className="btn btn-secondary btn-large"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Více informací
                  </motion.button>
                </div>
              </motion.div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Navigation arrows */}
      <button className="hero-nav hero-nav-prev" onClick={prevSlide}>
        <FaChevronDown />
      </button>
      <button className="hero-nav hero-nav-next" onClick={nextSlide}>
        <FaChevronDown />
      </button>

      {/* Slide indicators */}
      <div className="hero-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>

      {/* Quick contact info */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="hero-contact"
      >
        <div className="contact-item">
          <FaMapMarkerAlt />
          <span>Zdobnice 5, Rychnov nad Kněžnou</span>
        </div>
        <div className="contact-item">
          <FaPhone />
          <span>+420 775 112 341</span>
        </div>
        <div className="contact-item">
          <FaEnvelope />
          <span>info@penzionjilovanka.cz</span>
        </div>
      </motion.div>

      {/* Scroll down indicator */}
      <motion.div
        className="scroll-indicator"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        onClick={scrollToAbout}
      >
        <FaChevronDown />
        <span>Posunout dolů</span>
      </motion.div>
    </section>
  )
}

export default Hero
